/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminDepositAmountRespVo } from './AdminDepositAmountRespVo';
import {
    AdminDepositAmountRespVoFromJSON,
    AdminDepositAmountRespVoFromJSONTyped,
    AdminDepositAmountRespVoToJSON,
    AdminDepositAmountRespVoToJSONTyped,
} from './AdminDepositAmountRespVo';

/**
 * 
 * @export
 * @interface ResponseAdminDepositAmountRespVo
 */
export interface ResponseAdminDepositAmountRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminDepositAmountRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminDepositAmountRespVo
     */
    message?: string;
    /**
     * 
     * @type {AdminDepositAmountRespVo}
     * @memberof ResponseAdminDepositAmountRespVo
     */
    data?: AdminDepositAmountRespVo;
}

/**
 * Check if a given object implements the ResponseAdminDepositAmountRespVo interface.
 */
export function instanceOfResponseAdminDepositAmountRespVo(value: object): value is ResponseAdminDepositAmountRespVo {
    return true;
}

export function ResponseAdminDepositAmountRespVoFromJSON(json: any): ResponseAdminDepositAmountRespVo {
    return ResponseAdminDepositAmountRespVoFromJSONTyped(json, false);
}

export function ResponseAdminDepositAmountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminDepositAmountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminDepositAmountRespVoFromJSON(json['data']),
    };
}

export function ResponseAdminDepositAmountRespVoToJSON(json: any): ResponseAdminDepositAmountRespVo {
    return ResponseAdminDepositAmountRespVoToJSONTyped(json, false);
}

export function ResponseAdminDepositAmountRespVoToJSONTyped(value?: ResponseAdminDepositAmountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminDepositAmountRespVoToJSON(value['data']),
    };
}

